module.exports = __webpack_public_path__ + "img/slider-vertical.388bca0b.svg";